import React from 'react';
import AuthPanel from './AuthPanel';
import logo from '../assets/images/logo.png';

const navItems = [
  { id: 'library', label: 'Library' },
  { id: 'create', label: 'Create Link' },
  { id: 'shares', label: 'Shares' },
  { id: 'public', label: 'Live Share' },
  { id: 'admin', label: 'Admin', adminOnly: true },
];

function AppShell({ activePage, onNavigate, user, children }) {
  const isAdmin = user?.profile?.role === 'admin' || user?.role === 'admin';

  return (
    <main className="min-h-screen bg-[#f7f9fb] text-slate-950 antialiased">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3 px-2 py-4 sm:px-8 lg:flex-nowrap">
          <div className="order-1 flex items-center">
            <img className="h-9 w-auto" src={logo} alt="Sharabl" />
          </div>

          <nav className="order-3 flex w-full flex-wrap gap-2 lg:order-2 lg:ml-auto lg:w-auto" aria-label="Primary navigation">
            {navItems.filter((item) => !item.adminOnly || isAdmin).map((item) => (
              <button
                className={activePage === item.id ? 'nav-button active' : 'nav-button'}
                key={item.id}
                onClick={() => onNavigate(item.id)}
                type="button"
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="order-2 ml-auto flex items-center lg:order-3 lg:ml-0">
            <AuthPanel user={user} />
          </div>
        </div>
      </header>
      {children}
    </main>
  );
}

export default AppShell;
